import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';

// filter button
export const cagFilter = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-cag-filter', props.className );

    return (
        <div className={ widgetClassName } onClick={ () => props.onButtonClick() }>
            <div className='ui-cag-filter__title'>{ getLabel( props.filter.title ) }</div>
            <div className='ui-cag-filter__bottom'>
                <div className='ui-cag-filter__bottom__value'>{ props.displayValue }</div>
                <div className='ui-cag-filter__bottom__icon'>
                    <Icon name='edit' width='14' height='14'/>
                </div>
            </div>
        </div>
    );
};

// set display name
cagFilter.displayName = 'cagFilter';

// set default props
cagFilter.defaultProps = {
    onButtonClick: noop,
    filter: {}
};

// prop types
cagFilter.propTypes = {};
